<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.deleted')"
      show_usermenu
    ></my-header>
    <status-grid
      :gridData="getDeletedTaskData"
      gridType="deleted"
      @refresh="sendForData"
    ></status-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import StatusGrid from "../../components/tasks/StatusGrid";
import { mapGetters } from "vuex";
export default {
  methods: {
    sendForData() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getQueueTasks", 3)
        .then((result) => {
          if (result.length === 0) this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    this.sendForData();
  },
  computed: {
    ...mapGetters(["getDeletedTaskData"]),
  },
  components: {
    myHeader: Header,
    StatusGrid,
  },
};
</script>